
import VueRouter from 'vue-router'
import Vue       from 'vue'

Vue.use( VueRouter )

import FrameBody          from '../FrameBody'                    // ��������
import routerMid          from '../aiphoto/routerMid'            // ͬvue��˵���ת�м����

import DataCube           from '../aiphoto/DataCube'             // ����ħ��
import acctInfo           from '../aiphoto/acctInfo'             // �˻���Ϣ
import compInfo           from '../aiphoto/compInfo'             // ��˾��Ϣ
import SourceList         from '../aiphoto/SourceList'           // �ز��б�
import SourceNew          from '../aiphoto/SourceNew'            // �ϴ��ز�
import tmInfo             from '../aiphoto/tmInfo'               // ģ������
import tmList             from '../aiphoto/tmList'               // ģ������
import TemplaList         from '../aiphoto/TemplaList'           // ģ���б�
import TemplaEdit         from '../aiphoto/TemplaEdit'           // ģ��༭
import TemplaSetSource    from '../aiphoto/TemplaSetSource'      // ѡ���ز�
import ThumUpd            from '../aiphoto/thumupd'              // ����ģ������ͼ
import devList            from '../aiphoto/devList'              // �豸�б�
import photoList          from '../aiphoto/photoList'            // ���ռ�¼��ѯ
import payList            from '../aiphoto/payList'              // ֧����¼��ѯ
import devInfo            from '../aiphoto/devInfo'              // �豸��Ϣ
import adInfo             from '../aiphoto/adInfo'               // �����Ϣ
import devDevo            from '../aiphoto/devDevo'              // �豸�ƽ�
import feeMgr             from '../aiphoto/feeMgr'               // ���ѹ���
import feeNew             from '../aiphoto/feeNew'               // ����������Ϣ
import validityWarn       from '../aiphoto/validityWarn'         // ����Ԥ��
import upgradeMgr         from '../aiphoto/upgradeMgr'           // ��������
import verSelect          from '../aiphoto/verSelect'            // �����汾ѡ��
import verMgr             from '../aiphoto/verMgr'               // �汾����
import verNew             from '../aiphoto/verNew'               // �����°汾
import custList           from '../aiphoto/custList'             // ���ӿͻ��˺�
import cfcolor            from '../cf/cfcolor'                   // ѡ����ɫ
import aiDetail           from '../aiphoto/aiDetail'             // AI��ϸ
import aiInfo             from '../aiphoto/aiInfo'               // AI������Ϣ
import aiRech             from '../aiphoto/aiRech'               // AI����
import airNew             from '../aiphoto/airNew'               // ����AI����
import aiScene            from '../aiphoto/aiScene'              // AI����
import SceneNew           from '../aiphoto/SceneNew'             // AI����-����

//import cfcolor2           from '../cf/cfcolor2'                  // ѡ����ɫ

const routes = [
	{ component: FrameBody,   path: '/FrameBody',     name: 'FrameBody',
		children:[
			{ component: routerMid           , path:'routerMid',         name:'routerMid'   },
			{ component: DataCube            , path:'DataCube',          name:'DataCube'     },
			{ component: acctInfo            , path:'acctInfo',          name:'acctInfo'     },
			{ component: compInfo            , path:'compInfo',          name:'compInfo'     },
			{ component: aiInfo              , path:'aiInfo',            name:'aiInfo'       },
			{ component: devList             , path:'devList',           name:'devList',
				children:[
					{ component: devInfo     , path:'devInfo',           name:'devInfo'      },
					{ component: devDevo     , path:'devDevo',           name:'devDevo'      },
					{ component: adInfo      , path:'adInfo',            name:'adInfo'       },
				]},
			{ component: photoList           , path:'photoList',         name:'photoList',
				children:[
					{ component: aiDetail,   path:'aiDetail',            name:'aiDetail'    },
				]},
			{ component: payList             , path:'payList',           name:'payList'      },
			{ component: SourceList          , path:'SourceList',        name:'SourceList',
				children:[
					{ component: SourceNew   , path:'SourceNew',         name:'SourceNew'    },
				]},
			{ component: aiScene             , path:'aiScene',           name:'aiScene',
				children:[
					{ component: SceneNew    , path:'SceneNew',          name:'SceneNew'    },
				]},
			{ component: tmList              , path:'tmList',            name:'tmList',
				children:[
					{ component: tmInfo      , path:'tmInfo',            name:'tmInfo'       },
				]},
			{ component: TemplaList          , path:'TemplaList',        name:'TemplaList',
				children:[
					{ component: ThumUpd     , path:'ThumUpd',           name:'ThumUpd'      },
				]},
			{ component: TemplaEdit          , path:'TemplaEdit',        name:'TemplaEdit',
				children:[
					{ component: TemplaSetSource, path:'TemplaSetSource',         name:'TemplaSetSource'    },
					{ component: cfcolor     , path:'cfcolor',           name:'cfcolor'       },
					{ component: ThumUpd     , path:'ThumUpd',           name:'ThumUpd'      },
					//{ component: cfcolor2    , path:'cfcolor2',          name:'cfcolor2'    },
				]},
			{ component: feeMgr              , path:'feeMgr',            name:'feeMgr',
				children:[
					{ component: feeNew      , path:'feeNew',            name:'feeNew'        },
				]},
			{ component: aiRech              , path:'aiRech',            name:'aiRech',
				children:[
					{ component: airNew      , path:'airNew',            name:'airNew'        },
				]},
			{ component: verMgr              , path:'verMgr',            name:'verMgr',
				children:[
					{ component: verNew      , path:'verNew',            name:'verNew'        },
				]},
			{ component: validityWarn        , path:'validityWarn',      name:'validityWarn'  },
			{ component: upgradeMgr          , path:'upgradeMgr',        name:'upgradeMgr',
				children:[
					{ component: verSelect   , path:'verSelect',         name:'verSelect'     },
				]},
			{ component: custList            , path:'custList',          name:'custList'     },
		],
	},
]

const router = new VueRouter( { routes } )

export default router



// WEBPACK FOOTER //
// ./src/router/router.js